export default __webpack_public_path__ + "static/media/clerk@2x.49b6a39d.png";